import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { MomentModule } from 'ngx-moment';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { ShipmentAttachment } from '@qwyk/shared-stores/shipment-attachments';

@Component({
    standalone: true,
    imports: [NgIf, FontAwesomeModule, TranslateModule, MomentModule, TooltipModule, DialogModule],
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'li[qwyk-shipment-attachments-list-item]',
    templateUrl: './shipment-attachments-list-item.component.html',
    styleUrls: ['./shipment-attachments-list-item.component.scss'],
})
export class ShipmentAttachmentsListItemComponent {

    @Input() shipmentAttachment: ShipmentAttachment;
    @Input() disabled = false;
    @Input() canDelete = false;

    @Output()
    download: EventEmitter<ShipmentAttachment> = new EventEmitter<ShipmentAttachment>();
    @Output()
    delete: EventEmitter<ShipmentAttachment> = new EventEmitter<ShipmentAttachment>();
    @Output() preview: EventEmitter<ShipmentAttachment> =
        new EventEmitter<ShipmentAttachment>();
    @Output() openCarousel: EventEmitter<string> = new EventEmitter<string>();

    private readonly PREVIEWABLE_EXTENSIONS = [
        'jpeg',
        'jpg',
        'gif',
        'png',
        'pdf',
    ];
    private readonly THUMBNAIL_EXTENSIONS = ['jpeg', 'jpg', 'gif', 'png'];
    public showDeleteAttachmentModal = false;

    public get shouldDisableDownloadButton(): boolean {
        if (
            Object.prototype.hasOwnProperty.call(
                this.shipmentAttachment, 'attachment_link'
            )
        ) {
            return !this.shipmentAttachment.attachment_link?.data?.url;
        }
        return false;
    }

    public get canShowPreview(): boolean {
        return this.PREVIEWABLE_EXTENSIONS.includes(
            this.shipmentAttachment.extension.toLowerCase()
        );
    }

    public get canShowThumbnail(): boolean {
        return this.THUMBNAIL_EXTENSIONS.includes(
            this.shipmentAttachment.extension.toLowerCase()
        );
    }

    public onDownloadAttachment() {
        this.download.emit(this.shipmentAttachment);
    }

    public onDeleteAttachment() {
        this.showDeleteAttachmentModal = true;
    }

    public onPreviewAttachment(): void {
        this.preview.emit(this.shipmentAttachment);
    }

    public openGallery(): void {
        this.openCarousel.emit(`${this.shipmentAttachment.id}`);
    }

    public confirmAction(): void {
        this.delete.emit(this.shipmentAttachment);
        this.showDeleteAttachmentModal = false;
    }

    public cancelAction(): void {
        this.showDeleteAttachmentModal = false;
    }
}
